import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js

const AddPartyMaster = () => {
    const [name, setName] = useState('');
    const [number, setNumber] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [pincode, setPincode] = useState('');
    const [state, setState] = useState('');
    const [typeKarigar, setTypeKarigar] = useState('');
    const [dob, setDob] = useState('');
    const [aod, setAod] = useState('');
    const [mailId, setMailId] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Create party object
        const newParty = {
            name,
            number,
            address,
            city,
            pincode,
            state,
            type_karigar: typeKarigar,
            dob,
            aod,
            mail_id: mailId,
            password
        };

        try {
            const response = await fetch(`${BASE_URL}partymaster`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newParty),
            });

            const data = await response.json();

            if (data.status === 1) {
                // Redirect to the party master list page upon successful creation
                navigate('/PartyMasterList');
            } else {
                setError(data.message);
            }
        } catch (error) {
            console.error('Error creating party:', error);
            setError('There was an error creating the party.');
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Customer</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add Party Form */}
            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Add New Customer</h4>
                            </div>
                            <div className="card-body">
                                {error && <div className="alert alert-danger">{error}</div>}

                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="name"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="number" className="form-label">Contact Number</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="number"
                                            value={number}
                                            onChange={(e) => setNumber(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="address" className="form-label">Address</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="address"
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="city" className="form-label">City</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="city"
                                            value={city}
                                            onChange={(e) => setCity(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="pincode" className="form-label">Pincode</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="pincode"
                                            value={pincode}
                                            onChange={(e) => setPincode(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="state" className="form-label">State</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="state"
                                            value={state}
                                            onChange={(e) => setState(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="typeKarigar" className="form-label">Type of Karigar</label>
                                        <select
                                            className="form-control"
                                            id="typeKarigar"
                                            value={typeKarigar}
                                            onChange={(e) => setTypeKarigar(e.target.value)}
                                            required
                                        >
                                            <option value="Supplier">Supplier</option>
                                            <option value="Manufacturer">Customer</option>
                                            <option value="Dealer">Karigar</option>
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="dob" className="form-label">Date of Birth</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="dob"
                                            value={dob}
                                            onChange={(e) => setDob(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="aod" className="form-label">Anniversary Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="aod"
                                            value={aod}
                                            onChange={(e) => setAod(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="mailId" className="form-label">Email</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            id="mailId"
                                            value={mailId}
                                            onChange={(e) => setMailId(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="password" className="form-label">Password</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <button type="submit" className="btn btn-primary">Create Customer</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* End Add Party Form */}
        </div>
    );
};

export default AddPartyMaster;
